import { Slide } from "@jelly/lesson";

import { task as task01 } from "../../../../../task/course-05/lesson-03/task-01";

const task: Slide = {
  titleHtml:
    "Group the interior room surfaces according to their predominant response<br>to incident sound waves by dragging their images to one of the groups below.",
  description: "Drag and drop pictures.",
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "__task__",
        data: {
          id: task01.id,
        },
      },
    },
  },
};

export default task;
